import { getTimeZones } from '@vvo/tzdb';

const createTimeZonesOptions = ({ setTimeZonesOptions }) => {
  const timeZones = getTimeZones();
  const timeZonesOptions = timeZones.map(zone => {
    const [time] = zone.currentTimeFormat.split(' ');

    return {
      value: zone.name,
      label: `(${time}) ${zone.mainCities.join(', ')}`
    };
  });

  return setTimeZonesOptions(timeZonesOptions);
};

export default createTimeZonesOptions;
